export default {"src":"/_next/static/media/instagram-icon.d02e9197.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};